import {
  EntityStatusChip,
  type EntityStatusTone,
} from '../../../components/entity-detail/EntityStatusChip.js';
// UI-only status badge for outbox letters, shared by the mail table and the
// detail drawer. Colours follow the plan §7.3 mapping: success for delivered,
// error for failed/bounced, warning for pending.
import type { ReactElement } from 'react';
import { useTranslation } from '@govard/i18n-core/react';

import type { OutboxStatus } from '../api/admin.client.js';

const STATUS_TONES: Record<OutboxStatus, EntityStatusTone> = {
  pending: 'warning',
  sending: 'processing',
  sent: 'processing',
  delivered: 'success',
  bounced: 'error',
  failed: 'error',
  spam_complaint: 'error',
};

export function OutboxStatusBadge({ status }: { status: OutboxStatus }): ReactElement {
  const { t } = useTranslation();
  // Labels reuse the dashboard outbox keys — one wording per status.
  return (
    <EntityStatusChip tone={STATUS_TONES[status]} style={{ marginInlineEnd: 0, fontSize: 11 }}>
      {t(`crm.admin.outbox.status_${status}`)}
    </EntityStatusChip>
  );
}
